export default __webpack_public_path__ + "static/media/019_photo.4c940f4d.jpg";